import request from '@/utils/request'
// 首页数据
export function getHomeData() {
    return request({
        url: '/v1/goods/index',
        method: 'get',
    })
}
// 首页数据分页
export function getIndexGoods(params) {
    return request({
        url: '/v1/goods/getIndexGoods',
        method: 'get',
        params
    })
}